import React, { useState, useEffect } from 'react';
import '../../../Css/HotelForm.css'; // Import the CSS file

const HotelForm = ({ onAddHotel, editHotel, onUpdateHotel, onCancelEdit, onFetch }) => {
  const [formData, setFormData] = useState({
    nameHotel: '',
    category: '', // Initially set to '1' for one star
    hotel_rooms: [
      {
        room_title: '',
        room_details: [
          { prixType: '', logsimple: '', petidej: '', dejenner: '', dinner: '' },
        ],
      },
    ],
  });


  const [hoveredRating, setHoveredRating] = useState(0); // Store the hovered rating

  const token = localStorage.getItem('token'); // Get token from localStorage
  const apiUrl = process.env.REACT_APP_API_URL;

  const [roomss, setRooms] = useState([]);
  const [prixTypes, setPrixTypes] = useState([]);

  useEffect(() => {
    fetchRooms();
    fetchPrixTypes();
  }, []);

  useEffect(() => {

    const edithotels = async () => {
      if(editHotel){
        setFormData(editHotel); // Ensure data is always an array
      }
    };
    edithotels();
  }, [editHotel]);


  console.log("editHotellllll",editHotel);

  const fetchRooms = async () => {
    const response = await fetch(`${apiUrl}/api/rooms`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    const data = await response.json();
    setRooms(data || []); // Ensure data is always an array
  };

  const fetchPrixTypes = async () => {
    const response = await fetch(`${apiUrl}/api/type/prix`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    const data = await response.json();
    setPrixTypes(data || []); // Ensure data is always an array
  };

  const handleNameChange = (e) => {
    setFormData({ ...formData, nameHotel: e.target.value });
  };

  // Handle the category rating (star selection)
  const handleCategoryChange = (rating) => {
    setFormData({ ...formData, category: rating });
  };

  // Handle hover effect on stars
  const handleMouseEnter = (rating) => {
    setHoveredRating(rating);
  };

  // Handle mouse leave (reset hover)
  const handleMouseLeave = () => {
    setHoveredRating(0);
  };

  // Handle room changes
  const handleChange = (e, roomIndex, detailIndex = null) => {
    const { name, value } = e.target;
    const updatedRooms = [...formData.hotel_rooms];

    if (detailIndex !== null) {
      // Handle details change
      updatedRooms[roomIndex].room_details[detailIndex] = {
        ...updatedRooms[roomIndex].room_details[detailIndex],
        [name]: value,
      };
    } else {
      // Handle room change
      updatedRooms[roomIndex] = {
        ...updatedRooms[roomIndex],
        [name]: value, // this updates the 'room' field, not 'details'
      };
    }

    setFormData({ ...formData, hotel_rooms: updatedRooms });
  };

  // Add a new room
  const addRoom = () => {
    setFormData({
      ...formData,
      hotel_rooms: [
        ...formData.hotel_rooms,
        {
          room_title: '',
          room_details: [{ prixType: '', logsimple: '', petidej: '', dejenner: '', dinner: '' }],
        },
      ],
    });
  };

  // Delete a room
  const deleteRoom = (index) => {
    const newRooms = formData.hotel_rooms.filter((_, i) => i !== index);
    setFormData({ ...formData, hotel_rooms: newRooms });
  };

  // Add a new room detail
  const addRoomDetail = (roomIndex) => {
    const updatedRooms = [...formData.hotel_rooms];
    updatedRooms[roomIndex].room_details.push({
      logsimple: '',
      petidej: '',
      dejenner: '',
      dinner: '',
    });
    setFormData({ ...formData, rooms: updatedRooms });
  };

  // Delete a room detail
  const deleteRoomDetail = (roomIndex, detailIndex) => {
    const updatedRooms = [...formData.hotel_rooms];
    updatedRooms[roomIndex].room_details = updatedRooms[roomIndex].room_details.filter(
      (_, i) => i !== detailIndex
    );
    setFormData({ ...formData, rooms: updatedRooms });
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      nameHotel: '',
      category: '', 
      hotel_rooms: [
        { room_title: '', room_details: [{ prixType: '', logsimple: '', petidej: '', dejenner: '', dinner: '' }] },
      ],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const hotelResponse = await fetch(`${apiUrl}/api/hotel${editHotel ? `/update/${editHotel.id}` : ''}`, {
        method: editHotel ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          nameHotel: formData.nameHotel,
          category: formData.category, // Include category in the request
          hotel_rooms: formData.hotel_rooms,
        }),
      });

      if (!hotelResponse.ok) {
        const errorData = await hotelResponse.json();
        throw new Error(`Failed to ${editHotel ? 'update' : 'add'} hotel: ${errorData.message}`);
      }
      alert(`${editHotel ? 'Updated' : 'Added'} hotel successfully!`);
      resetForm();
      onCancelEdit();
      onFetch();
    } catch (error) {
      console.error('Error submitting form:', error);
      alert(`An error occurred: ${error.message}`);
    }
  };


  return (
    <form className="Hotels__reservation-form" onSubmit={handleSubmit}>
      <h2 className="Facturetablie__title">Ajouter Hotel</h2>
      <div className="Hotels__reservation-form__group">
        <div className="Hotels__reservation-form__group-section">
          <label htmlFor="nameHotel">Nom de l'hôtel</label>
          <input
            type="text"
            id="nameHotel"
            name="nameHotel"
            value={formData.nameHotel}
            onChange={handleNameChange}
            required
          />
        </div>
        <div>
          <label htmlFor="category">Category</label>
          <div className="stars-container">
            {[1, 2, 3, 4, 5].map((rating) => (
              <span
                key={rating}
                className={`star ${formData.category >= rating || hoveredRating >= rating ? 'selected' : ''}`}
                onClick={() => handleCategoryChange(rating)}
                onMouseEnter={() => handleMouseEnter(rating)}
                onMouseLeave={handleMouseLeave}
              >
                ★
              </span>
              ))}
          </div>  
        </div>
      </div>

      {/* Rooms Table */}
      <table className="Hotels__reservation-table">
        <tbody className="Hotels__table-body">
          <tr className="Hotels__table-header Hotels__table-header--highlight Hotels__table-header--bold">
            <td>Type Chambre</td>
            <td>Prix Type</td>
            <td>Logement simple</td>
            <td>petit déj</td>
            <td>Déjenner</td>
            <td>Dinner</td>
            <td colSpan={2}>Actions</td>
          </tr>
          {formData.hotel_rooms.map((room, roomIndex) => (
            <React.Fragment key={roomIndex}>
              <tr className="Hotels__table-row">
                <td style={{ width: '140px' }}>
                  <select
                    id={`room-${roomIndex}`}
                    name="room_title"
                    value={room.room_title}
                    onChange={(e) => handleChange(e,roomIndex)} // Change the room for this index
                    required
                  >
                    <option value="" disabled>اختر غرفة</option>
                    {roomss.map((roomOption) => (
                      <option key={roomOption.id} value={roomOption.title}>
                        {roomOption.title}
                      </option>
                    ))}
                  </select>
                </td>

                {roomIndex > 0 && (
                  <td>
                    <button
                      type="button"
                      onClick={() => deleteRoom(roomIndex)}
                      className="Hotels__form__button--delete"
                    >
                      Supprimer chambre
                    </button>
                  </td>
                )}
              </tr>

              {room.room_details.map((detail, detailIndex) => (
                <tr className="Hotels__table-row" key={detailIndex}>
                  <td></td>
                  <td style={{ width: '140px' }}>
                    <select
                      name="prixType"
                      value={detail.prixType}
                      onChange={(e) => handleChange(e ,roomIndex, detailIndex)}
                      required
                    >
                      <option value="" disabled>اختر نوع السعر</option>
                      {prixTypes.map((type) => (
                        <option key={type.id} value={type.title}>
                          {type.title}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <input
                      type="number"
                      name="logsimple"
                      value={detail.logsimple}
                      onChange={(e) => handleChange(e, roomIndex, detailIndex)}
                      required
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="petidej"
                      value={detail.petidej}
                      onChange={(e) => handleChange(e, roomIndex, detailIndex)}
                      required
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="dejenner"
                      value={detail.dejenner}
                      onChange={(e) => handleChange(e, roomIndex, detailIndex)}
                      required
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="dinner"
                      value={detail.dinner}
                      onChange={(e) => handleChange(e, roomIndex, detailIndex)}
                      required
                    />
                  </td>

                  <td style={{ width: '100px' }}>
                    <button
                      type="button"
                      onClick={() => addRoomDetail(roomIndex)}
                      className="hotel-form__button--add2"
                    >
                      Ajouter
                    </button>
                  </td>

                  {room.room_details.length > 1 && (
                    <td style={{ width: '100px' }}>
                      <button
                        type="button"
                        onClick={() => deleteRoomDetail(roomIndex, detailIndex)}
                        className="Hotels__form__button--delete"
                      >
                        Supprimer
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      <div className="hotel-form__buttons">
        <button
          type="button"
          className="hotel-form__button hotel-form__button--add"
          onClick={addRoom}
        >
          Ajouter chambre
        </button>
        <button type="submit" className="hotel-form__button hotel-form__button--submit">
          Enregistrer
        </button>
        {editHotel && (
          <button
            type="button"
            className="hotel-form__button hotel-form__button--cancel"
            onClick={() => {
              onCancelEdit?.();
              resetForm();
            }}
          >
            Annuler
          </button>
        )}
      </div>
    </form>
  );
};

export default HotelForm;
